import {
  SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY,
  DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY,
  DISPLAY_CAPACITY_DIALOG,
  HIDE_CAPACITY_DIALOG,
  DISPLAY_EVENTS_IN_DDL,
  SET_SQUAD_VISIBILITY
} from './constants';

const initialState = {
  squads: [],
  modalVisible: false,
  modalTitle: '',
  loadingSquads: true
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY:
      return {
        ...state,
        ...{squads: state.squads.map(squad => squadReducer(squad, {
          type,
          payload
        }))}
      };
    case DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY:{
      return {
        ...state,
        loadingSquads: payload ? false : true,
        ...{squads: payload}
      };
    }
    case DISPLAY_CAPACITY_DIALOG:
      return {
        ...state,
        ...{
          modalVisible: true,
          modalTitle: payload
        }
      };
    case HIDE_CAPACITY_DIALOG:
      return {
        ...state,
        ...{modalVisible: false}
      };
    case DISPLAY_EVENTS_IN_DDL:
      return {
        ...state,
        ...{eventTypes: payload}
      };
    case SET_SQUAD_VISIBILITY:
      return {
        ...state,
        ...{squads: state.squads.map(squad => squadReducer(squad, {
          type,
          payload
        }))}
      };

    default:
      return state;
  }
};

const squadReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY:
      if(state.id !== payload.id) {
        return state;
      }
      return {
        ...state,
        ...{
          numberAvailableForPurchase: Number(payload.value),
          dirty: Number(state.numberAvailableForPurchase) !== Number(payload.value)
        }
      };
    case SET_SQUAD_VISIBILITY:
      if(state.id !== payload.id) {
        return state;
      }
      return {
        ...state,
        ...{
          hideFromCaptains: payload.value
        }
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/reducer.js